module.exports = __webpack_public_path__ + "static/assets/6bb1d7fe5d49d29f42c765dcf226ec6b.png";